module.exports = __webpack_public_path__ + "img/Profil_CS-Ecoii_Universal.4fea7c18.jpg";